module.exports = __webpack_public_path__ + "img/085.db843c8e.png";